import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import CourseGallery from "../../../features/courseGallery/CourseGallery";
import classes from "./DiscoveryGalleries.module.css";

const DiscoveryGalleries = () => {
    
    const { texts, lang } = useSelector(state => state.translate);
    const studentkita = useSelector(state => state.auth.user?.studentkita);

    const popularFilters = useMemo(() => [
        { by: "tags", value: "popular" },
        ...(studentkita != null && studentkita !== "" ? [{ operator: "student_grade", value: studentkita }] : [])
    ], []);

    const makpezaFilters = useMemo(() => [
        { by: "category", value: "makpeza" },
        { by: "languages", value: lang },
        ...(studentkita != null && studentkita !== "" ? [{ operator: "student_grade", value: studentkita }] : [])
    ], []);

    const bagrutFilters = useMemo(() => [
        { by: "tags", value: "bagrut" },
        ...(studentkita != null && studentkita !== "" ? [{ operator: "student_grade", value: studentkita }] : [])
    ], []);

    const enrichmentFilters = useMemo(() => [
        { by: "category", value: "enriching" },
        { by: "languages", value: lang },
        ...(studentkita != null && studentkita !== "" ? [{ operator: "student_grade", value: studentkita }] : [])
    ], []);


    const popularCourses = useSelector(state => selectEntitiesByFilters(state, popularFilters));

    const makpezaCourses = useSelector(state => selectEntitiesByFilters(state, makpezaFilters));

    const bagrutCourses = useSelector(state => selectEntitiesByFilters(state, bagrutFilters));

    const enrichmentCourses = useSelector(state => selectEntitiesByFilters(state, enrichmentFilters));

    return (
        <div className={classes.DiscoveryGalleries}>
            <div className={classes.GalleriesContainer}>
                <div className={classes.GallerySection}>
                    <CourseGallery
                        courses={popularCourses}
                        title={texts.popularCourses}
                    />
                </div>

                <div className={classes.GallerySection}>
                    <CourseGallery
                        courses={makpezaCourses}
                        title={texts.makpeza}
                    />
                </div>

                <div className={classes.GallerySection}>
                    <CourseGallery
                        courses={bagrutCourses}
                        title={texts.bagrutPreparationCourses}
                    />
                </div>

                <div className={classes.GallerySection}>
                    <CourseGallery
                        courses={enrichmentCourses}
                        title={texts.enrichmentForYou}
                    />
                </div>
            </div>
        </div>
    );
};

export default DiscoveryGalleries; 